import { stringify, parse } from 'qs'

export const parseQuery = query => parse(query, { ignoreQueryPrefix: true })
export const stringifyQuery = query => stringify(query, { arrayFormat: 'brackets', addQueryPrefix: true })



// WEBPACK FOOTER //
// ./src/helpers/queryHelpers.js